import * as React from 'react';
import { DRFReactBySchemaProvider } from 'drf-react-by-schema';

import MainNavigation from './components/MainNavigation';
import CONSTANTS from './constants/common';
import { useAppSelector } from './app/hooks';
import { getTheme } from './styles/theme';

export default function AppInner() {
  const perfil = useAppSelector((state) => state.page.perfil);
  const theme = React.useMemo(() => {
    return getTheme(perfil?.tipo);
  }, [perfil?.tipo]);
  return (
    <DRFReactBySchemaProvider
      serverEndPoint={{
        url: CONSTANTS.API.url,
        apiTokenUrl: CONSTANTS.API.apiTokenUrl,
        signUp: CONSTANTS.API.signUp,
      }}
      theme={theme}>
      <MainNavigation />
    </DRFReactBySchemaProvider>
  );
}
